export type Table<T> = Record<string, T>;

export function mapTable<T, U>(table: Table<T>, fn: (value: T) => U): Table<U> {
  return Object.fromEntries(Object.entries(table).map(([key, value]) => [key, fn(value)]));
}
